<div *ngIf="loading" class="loader-container">  
        <div *ngIf="!!message">
            <div class="loader-message-container">
                {{message}}
            </div>
        </div>  
</div>
